// ── Conversation kind icon ────────────────────────────────────────────────────
// The icon on a history row: a microphone for a conversation that was spoken
// (in the voice chat, or on the phone), the usual speech bubble for one that
// was typed. One component so every history list says it the same way.

import React from 'react';
import { FiMessageSquare, FiMic } from 'react-icons/fi';
import './ConversationKindIcon.css';

interface ConversationKindIconProps {
  isVoice?: boolean | null;
  size?: number;
  className?: string;
}

const ConversationKindIcon: React.FC<ConversationKindIconProps> = ({ isVoice, size = 14, className }) =>
  isVoice ? (
    <span className="conversation-kind conversation-kind--voice" title="Voice conversation">
      <FiMic size={size} className={className} aria-label="Voice conversation" role="img" />
    </span>
  ) : (
    <FiMessageSquare size={size} className={className} aria-hidden="true" />
  );

export default ConversationKindIcon;
